import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { ListDocumentProfileSurveyService } from '../../../service/list-document-profile-survey/list-document-profile-survey.service';
import { ListDocumentProfileSurvey } from '../../../class/list-document-profile-survey';

@Component({
  selector: 'app-list-document-profile-survey',
  templateUrl: './list-document-profile-survey.component.html',
  styleUrls: ['./list-document-profile-survey.component.scss']
})
export class ListDocumentProfileSurveyComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoListDocumentProfileSurvey: ListDocumentProfileSurvey;
    public gestionSAC: ListDocumentProfileSurvey;
    public msgs: Message[] = [];
    public options: any;
    public latitude: number;
    public longitude: number;
    public zoom: number;
    public overlays: any[];

    constructor(
        public listDocumentProfileSurveyService: ListDocumentProfileSurveyService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public addMarker(lat, lng, title) {
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelListDocumentProfileSurvey () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/list-document-profile-surveis/list-document-profile-survey/list-document-profile-survey.component.ts